import React from "react";
import "./funnel-chart.css";

const funnelData = [
    { label: "Sent", percent: 100, color: "#EF4444" },
    { label: "Delivered", percent: 100, color: "#F59E0B" },
    { label: "Read", percent: 86, color: "#10B981" },
    { label: "Clicked", percent: 28, color: "#3B82F6", isArrow: true },
];

interface FunnelDataItemProps {
    label: string;
    percent: number;
    total: number;
    averagePercent?: number;
}

interface FunnelDataProps {
    items: FunnelDataItemProps[];
    campaignId?: number;
}

const FunnelChart = ({ items, campaignId }: FunnelDataProps) => {
    const colors = [
        'rgba(99,195,255,0.45)',
        'rgba(99,195,255,0.65)',
        'rgba(99,195,255,0.84)',
        'rgba(99,195,255,0.84)',
        '#63c3ff',
    ];

    const compareColors = [
        'rgba(223,223,223,0.45)',
        'rgba(223,223,223,0.65)',
        'rgba(223,223,223,0.85)',
        'rgba(223,223,223,0.85)',
        '#dfdfdf',
    ]
    return (
        <div className="funnel-wrapper">
            {items.map((item, index) => <div key={`funnel-item-${item.label}-${campaignId}`} className="funnel-item-container">
                <div className="funnel-item">
                    <div className="progress" style={{ width: `${item.percent * 70 / 100}%`, background: colors[index] }}>{Math.round(item.percent)}%</div>
                    <div className="label">{item.label} ({item.total})</div>
                </div>
                {item.averagePercent ? <div className="funnel-compare-item">
                    <div className="progress" style={{ width: `${item.averagePercent * 70 / 100}%`, background: compareColors[index] }}>{Math.round(item.averagePercent)}%</div>

                </div> : null}
            </div>)}
        </div>
    );
};

export default FunnelChart;

/* FunnelChart.css */
